import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReferrerTimelineList from "./referrer-timeline/referrer-timeline-list.vue";
import ReferrerTimelineChangelog from "./referrer-timeline/referrer-timeline-changelog.vue";
import ReferrerActivityConvertModal from "./referrer-timeline/referrer-activity-convert-modal.vue";
import { FILTER_REFERRER_TIMELINE_LIST } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { LOAD_REFERRER_TIMELINE, LOAD_REFERRER_CHANGELOG } from "@Broker/@Modules/clients/referrers/store/referrer-actions.ts";
import { capitalize } from "lodash";
import { mapActions, mapGetters } from "vuex";
import Navbar from "@Shared/components/general/nav-bar.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTimelineContainer",
  components: {
    ReferrerTimelineList,
    ReferrerTimelineChangelog,
    ReferrerActivityConvertModal,
    Navbar
  },
  props: {
    referrerId: {
      type: [String, Number],
      required: true
    },
    loadingChangelog: {
      type: Boolean,
      default: false
    },
    timelineTab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentTab: "all"
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", [FILTER_REFERRER_TIMELINE_LIST])), {}, {
    timelineList() {
      return this.FILTER_REFERRER_TIMELINE_LIST({
        id: this.referrerId,
        filter: this.currentTab
      });
    },
    isEmptyTimeline() {
      var _context;
      return _reduceInstanceProperty(_context = this.timelineList).call(_context, (isEmpty, current) => isEmpty && !current.items.length, true);
    },
    tabs() {
      return [{
        value: "pinned",
        label: "<i class='fa fa-thumb-tack' aria-hidden='true'></i>"
      }, {
        value: "all",
        label: this.$tc("global.words.all", 1)
      }, {
        value: "changelog",
        label: this.$t("global.words.changeLog")
      }, {
        value: "note",
        label: capitalize(this.$tc("global.words.note", 2))
      }, {
        value: "follow-up",
        label: capitalize(this.$tc("global.words.activity", 2))
      }, {
        value: "checklist",
        label: this.$tc("global.words.checklist", 2)
      }];
    },
    isChangelog() {
      return this.currentTab === "changelog";
    }
  }),
  watch: {
    currentTab: {
      handler(value) {
        this.$emit("update:timeline-tab", value);
        if (value === "changelog") return this.loadChangelog();
      },
      immediate: true
    }
  },
  mounted() {
    this.addTooltip();
    this.loadTimeLine();
  },
  updated() {
    this.addTooltip();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [LOAD_REFERRER_TIMELINE, LOAD_REFERRER_CHANGELOG])), {}, {
    addTooltip() {
      this.$nextTick(() => {
        $("[data-toggle='tooltip']").tooltip();
      });
    },
    activeItem(tab) {
      return this.currentTab === tab;
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    async loadTimeLine() {
      await this.LOAD_REFERRER_TIMELINE({
        referrerId: this.referrerId
      });
    },
    async loadChangelog() {
      await this.LOAD_REFERRER_CHANGELOG({
        referrerId: this.referrerId
      });
    }
  })
});